import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  BasketItem,
  WithSubscriptionComponent,
  EnterpriseSearchService,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';
import { UiHelpers } from '../../../../core/classes/ui-helpers';
import { FlightBasketDetails, Journey } from '../../../../core/interfaces/flight-basket-details';

@Component({
  selector: 'app-basket-eurostar',
  templateUrl: './basket-eurostar.component.html',
  styleUrls: ['./basket-eurostar.component.scss'],
  standalone: false
})
export class BasketEurostarComponent extends WithSubscriptionComponent implements OnInit {
  @Input() eurostar: BasketItem;
  @Input() duplicateBooking = false;
  @Output() remove: EventEmitter<void> = new EventEmitter<void>();
  @Output() openChangeModal: EventEmitter<void> = new EventEmitter<void>();
  @Input() displayItinerary = false;

  eurostarToDisplay: BasketItem;
  euroStations: { gateway: string; destination: string }[];
  noOfOutbounds: number;
  travellers = [];

  constructor(
    private searchService: EnterpriseSearchService,
    private modalOpenerService: ModalOpenerService
  ) {
    super();
  }

  ngOnInit(): void {
    this.eurostarToDisplay = { ...this.eurostar };
    this.eurostarToDisplay.detail.flights = [
      ...this.eurostar.detail.outboundFlights,
      ...this.eurostar.detail.inboundFlights
    ];
    this.noOfOutbounds = this.eurostar.detail.outboundFlights.length;
    this.travellers = [...(this.eurostar?.users || []), ...(this.eurostar?.guests || [])];
    console.log(this.eurostarToDisplay.detail.flights);
    this.subscribe(this.searchService.lookupEurostarStations(''), (data) => {
      this.euroStations = data;
    });
  }

  makeJourneys(flights: FlightBasketDetails[]): Journey[] {
    return UiHelpers.makeJourneys(flights);
  }
  getFullStationName(station: string): string {
    return this.euroStations.find((eStation) => eStation.gateway === station).destination;
  }

  openFareRules(): void {
    this.modalOpenerService.open(LightningModalTypes.ModalFareRulesComponent, {
      windowClass: 'fare-rules-modal',
      centered: true
    });
  }
}
